import { ChatDetailsResponse } from '@choco-admin/types';
import { Card, CardBody, Divider } from '@heroui/react';
import React from 'react';
import { FiUsers } from 'react-icons/fi';

import { PageHeader } from '../PageHeader';

import { BuyerSection } from './participants/BuyerSection';
import { BuyerUsersSection } from './participants/BuyerUsersSection';
import { SupplierSection } from './participants/SupplierSection';
import { SupplierUsersSection } from './participants/SupplierUsersSection';

interface ParticipantsTabPanelProps {
  chatData: ChatDetailsResponse;
  chatId: string;
}

export const ParticipantsTabPanel: React.FC<ParticipantsTabPanelProps> = ({
  chatData,
  chatId,
}) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardBody className="space-y-8">
          <PageHeader
            title="Chat Participants"
            subtitle="Manage the buyer, supplier, and users involved in this chat."
            icon={<FiUsers className="w-6 h-6 text-primary" />}
          />

          {/* Supplier Section */}
          <SupplierSection chatData={chatData} chatId={chatId} />

          {/* Supplier Users Section */}
          <SupplierUsersSection chatData={chatData} chatId={chatId} />

          <Divider className="my-8" />

          {/* Buyer Section */}
          <BuyerSection chatData={chatData} chatId={chatId} />

          {/* Buyer Users Section */}
          <BuyerUsersSection chatData={chatData} chatId={chatId} />
        </CardBody>
      </Card>
    </div>
  );
};
